import { computed, ref, onMounted, nextTick, onUnmounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a1a0928"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "login-loading"
};
const __default__ = {
  name: 'layoutHomeIndex'
};
import Sider from '@/views/home/components/Sider.vue';
import PathHeader from '@/components/PathHeader.vue';
import { useStore } from '@/store';
import Axios from 'axios';
import { Modal } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const store = useStore();
    const cachedName = computed(() => useStore().cachedName); // 页面缓存状态动态获取
    const collapsed = computed(() => useStore().isCollapsed);
    const pathHeader = ref();
    const loginReady = ref(false); // getActiveUser 完成后再挂载布局和业务页面
    let timer = null;
    const updateCollapsed = () => {
      store.isCollapsed = window.innerWidth < 1200;
    };
    const checkVersion = async () => {
      return new Promise(resolve => {
        Axios.get('/version.json?v=' + new Date().getTime(), {
          headers: {
            'Cache-Control': 'no-cache'
          },
          baseURL: window.location.origin
        }).then(res => {
          const version = res === null || res === void 0 ? void 0 : res['version'];
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          const clientVersion = Number(document.querySelector('#BPMVersion').content || '');
          resolve(version === clientVersion);
        }).catch(err => {});
      });
    };
    // 增加页面切换动画
    const beforeEnter = el => {
      el.style.opacity = 0;
    };
    const enter = (el, done) => {
      el.offsetHeight; // trigger reflow
      el.style.transition = 'opacity 1s';
      el.style.opacity = 1;
      done();
    };
    const leave = (el, done) => {
      el.style.transition = 'opacity 1s';
      el.style.opacity = 0;
      done();
    };
    onMounted(async () => {
      var _pathHeader$value;
      await store.ssoLogin();
      loginReady.value = true;
      await nextTick();
      (_pathHeader$value = pathHeader.value) === null || _pathHeader$value === void 0 || _pathHeader$value.getUserNotice();
      const isDev = process.env.NODE_ENV === 'development';
      if (!isDev) {
        timer = setInterval(() => {
          checkVersion().then(res => {
            if (!res) {
              clearInterval(timer);
              Modal.info({
                title: '更新提示',
                centered: true,
                showCancelButton: false,
                okText: '立即更新',
                content: '刷新页面即可更新版本',
                onOk: () => {
                  window.location.reload();
                }
              });
            }
          });
        }, 60000);
      }
      // 监听页面宽度
      window.addEventListener('resize', updateCollapsed);
      // 首次进来判断是否折叠
      updateCollapsed();
    });
    onUnmounted(() => {
      clearInterval(timer);
      window.removeEventListener('resize', updateCollapsed);
    });
    return (_ctx, _cache) => {
      const _component_a_layout_sider = _resolveComponent("a-layout-sider");
      const _component_router_view = _resolveComponent("router-view");
      const _component_a_layout_content = _resolveComponent("a-layout-content");
      const _component_a_layout = _resolveComponent("a-layout");
      const _component_a_spin = _resolveComponent("a-spin");
      return loginReady.value ? (_openBlock(), _createBlock(_component_a_layout, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_a_layout, null, {
          default: _withCtx(() => [_createVNode(_component_a_layout_sider, {
            width: "180px",
            collapsed: _unref(collapsed),
            "onUpdate:collapsed": _cache[0] || (_cache[0] = $event => _isRef(collapsed) ? collapsed.value = $event : null),
            trigger: null,
            collapsible: "",
            collapsedWidth: 74
          }, {
            default: _withCtx(() => [_createVNode(Sider)]),
            _: 1
          }, 8, ["collapsed"]), _createVNode(_component_a_layout_content, null, {
            default: _withCtx(() => [_createVNode(PathHeader, {
              ref_key: "pathHeader",
              ref: pathHeader
            }, null, 512), _createVNode(_component_router_view, {
              style: {
                "padding": "16px",
                "height": "calc(100vh - 54px)",
                "overflow-y": "auto"
              }
            }, {
              default: _withCtx(({
                Component
              }) => [_createVNode(_Transition, {
                name: "fade",
                onBeforeEnter: beforeEnter,
                onEnter: enter,
                onLeave: leave
              }, {
                default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
                  include: _unref(cachedName)
                }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
                _: 2
              }, 1024)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_spin, {
        size: "large"
      })]));
    };
  }
});